module.exports = __webpack_public_path__ + "img/yuan.5da82f69.jpg";